module.exports = ".login-title {\n  margin-bottom: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/register/register.component.scss
// module id = ./src/app/register/register.component.scss
// module chunks = main